/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return null!=n&&!n.readyToRun}export{n as ensureClouds};
